import type { Stop } from "~/features/ftl/shared/ftl-stop";

import * as styles from "./quote-summary-nuggets.module.css";

type LoadValue = {
	code: string;
	displayName: string;
};

type TrailerType = {
	code: string;
	displayName: string;
	isRefrigerated: boolean;
};

type QuoteSummaryData = {
	stops: Stop[];
	loadValue?: LoadValue;
	commodity: string;
	hazmat: boolean;
	trailerType?: TrailerType;
};

type QuoteSummaryNuggetsProps = {
	readonly formData: QuoteSummaryData;
	readonly quoteId?: number;
};

export function QuoteSummaryNuggets({
	formData,
	quoteId,
}: QuoteSummaryNuggetsProps) {
	return (
		<div className={styles.quoteDetailsNuggets}>
			<div className={styles.vipNuggets}>
				<div className={styles.displayLabel}>First Pickup Date:</div>
				<div>{formData.stops[0]?.stopDate?.toLocaleDateString()}</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Last Delivery Date:</div>
				<div>{formData.stops.at(-1)?.stopDate?.toLocaleDateString()}</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Stops:</div>
				<div>{formData.stops.length}</div>
			</div>
			<div className={styles.vipNuggets}>
				<div className={styles.displayLabel}>Lane:</div>
				<div>
					{formData.stops[0]?.location?.state} to{" "}
					{formData.stops.at(-1)?.location?.state}
				</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Load Value:</div>
				<div>{formData.loadValue?.displayName}</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Commodity:</div>
				<div>{formData.commodity}</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Hazmat Load</div>
				<div>{formData.hazmat ? "Yes" : "No"}</div>
			</div>
			<div className={styles.regNuggets}>
				<div className={styles.displayLabel}>Trailer Type:</div>
				<div>{formData.trailerType?.displayName}</div>
			</div>
			<div className={styles.vipNuggets}>
				<div className={styles.displayLabel}>Quote ID:</div>
				<div>{quoteId ?? ""}</div>
			</div>
		</div>
	);
}
